/**
 * @generated SignedSource<<3cdf17e01ef70349c807f078d8c0ba44>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type WorkspaceRole = "ADMIN" | "MEMBER" | "OWNER" | "%future added value";
export type AcceptInvitePageMutation$variables = {
  token: string;
};
export type AcceptInvitePageMutation$data = {
  readonly acceptWorkspaceInvite: {
    readonly invite: {
      readonly email: string;
    };
    readonly member: {
      readonly role: WorkspaceRole;
    } | null | undefined;
    readonly requiresAccount: boolean;
    readonly requiresLogin: boolean;
    readonly workspace: {
      readonly id: string;
      readonly name: string;
    };
  };
};
export type AcceptInvitePageMutation = {
  response: AcceptInvitePageMutation$data;
  variables: AcceptInvitePageMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "token"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "token",
    "variableName": "token"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "Workspace",
  "kind": "LinkedField",
  "name": "workspace",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "role",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "requiresAccount",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "requiresLogin",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AcceptInvitePageMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "WorkspaceAcceptResult",
        "kind": "LinkedField",
        "name": "acceptWorkspaceInvite",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "WorkspaceMember",
            "kind": "LinkedField",
            "name": "member",
            "plural": false,
            "selections": [
              (v4/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "WorkspaceInvite",
            "kind": "LinkedField",
            "name": "invite",
            "plural": false,
            "selections": [
              (v5/*: any*/)
            ],
            "storageKey": null
          },
          (v6/*: any*/),
          (v7/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AcceptInvitePageMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "WorkspaceAcceptResult",
        "kind": "LinkedField",
        "name": "acceptWorkspaceInvite",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "WorkspaceMember",
            "kind": "LinkedField",
            "name": "member",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "WorkspaceInvite",
            "kind": "LinkedField",
            "name": "invite",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          (v6/*: any*/),
          (v7/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "7e83bb86ca547dd9f4179fe704cbe63d",
    "id": null,
    "metadata": {},
    "name": "AcceptInvitePageMutation",
    "operationKind": "mutation",
    "text": "mutation AcceptInvitePageMutation(\n  $token: String!\n) {\n  acceptWorkspaceInvite(token: $token) {\n    workspace {\n      id\n      name\n    }\n    member {\n      role\n      id\n    }\n    invite {\n      email\n      id\n    }\n    requiresAccount\n    requiresLogin\n  }\n}\n"
  }
};
})();

(node as any).hash = "be16f5a32ca45faf30390efb0563d9a5";

export default node;
